"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckoutConsignmentPickupPointDeliveryAddressesPath = exports.getCheckoutConsignmentPickupPointDeliveryAddresses = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const getCheckoutConsignmentPickupPointDeliveryAddresses = (client) => async ({ checkoutId, consignmentId }) => {
    try {
        const response = await client.get((0, exports.getCheckoutConsignmentPickupPointDeliveryAddressesPath)(checkoutId, consignmentId));
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.getCheckoutConsignmentPickupPointDeliveryAddresses = getCheckoutConsignmentPickupPointDeliveryAddresses;
const getCheckoutConsignmentPickupPointDeliveryAddressesPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/pickup-point-delivery-addresses`;
exports.getCheckoutConsignmentPickupPointDeliveryAddressesPath = getCheckoutConsignmentPickupPointDeliveryAddressesPath;
